module.exports = __webpack_public_path__ + "img/search.4319624d.svg";